import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { Switch } from '../../Switch'

import * as styles from './SettingsSwitch.module.css'

function SettingsSwitch({
  labelKeys,
  tooltipKeys = EMPTY_OBJECT,
  value,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Switch
      {...restProps}
      className={styles.SettingsSwitch}
      label={t(value ? labelKeys.on : labelKeys.off)}
      tooltip={t(value ? tooltipKeys.on : tooltipKeys.off)}
      value={value}
    />
  )
}

export default SettingsSwitch
